import React from 'react';
import { GoogleLoginButton } from 'react-social-login-buttons';
import { IResolveParams, LoginSocialGoogle } from 'reactjs-social-login';

type Provider = 'Google';

type providersIcon = {
  [item in Provider]?: React.ReactNode;
};

type providerText = {
  [item in Provider]?: string;
};

interface ISocialAuth {
  className?: string;
  providers: Provider | Array<Provider>;
  clientIds?: Record<Provider, string | undefined>;
  providersIcon?: providersIcon;
  providersRelatedClassName?: Record<Provider, string>;
  redirectUrl?: string;
  rest?: any;
  text?: providerText;
  onLoginStartSocialAuthStart: () => void;
  onResolveSocialAuth: (provider: IResolveParams['provider'], data: IResolveParams['data']) => void;
  onRejectSocialAuth: (err: any) => void;
}

const defaultClientIds = {
  Google: import.meta.env.VITE_GG_APP_ID,
};

const SocialAuth = ({
  clientIds = { ...defaultClientIds },
  providersIcon,
  providersRelatedClassName,
  providers,
  className,
  text,
  rest,
  onLoginStartSocialAuthStart,
  onResolveSocialAuth,
  onRejectSocialAuth,
}: ISocialAuth) => {
  return (
    <div className={className} {...rest}>
      {(providers === 'Google' || providers.includes('Google')) && (
        <LoginSocialGoogle
          isOnlyGetToken
          client_id={clientIds.Google || ''}
          scope={'profile email'}
          onLoginStart={onLoginStartSocialAuthStart}
          onResolve={({ provider, data }: IResolveParams) => {
            onResolveSocialAuth(provider, data);
          }}
          onReject={err => {
            onRejectSocialAuth(err);
          }}
        >
          <div className={providersRelatedClassName?.Google}>{providersIcon?.Google || <GoogleLoginButton text={text?.Google} />}</div>
        </LoginSocialGoogle>
      )}
    </div>
  );
};

export default SocialAuth;
